import { Injectable } from '@angular/core';

import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { AngularFireAuth } from 'angularfire2/auth';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as firebase from 'firebase/app';
import { Birthday } from '../models/birthday.model';

@Injectable()
export class DvlBirthdaysService {
  public birthdays$: BehaviorSubject<Birthday[]>;
  public birthdaysDB$: FirebaseListObservable<Birthday[]>;
  public selectedData: string;

  constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase) {
    this.birthdays$ = new BehaviorSubject<Birthday[]>([]);
    this.selectedData = new Date().toISOString().split('T')[0];

    this.birthdaysDB$ = af.list(`/birthdays/${this.selectedData}`);
    this.birthdaysDB$.subscribe((birthdays) => this.birthdays$.next(birthdays));
  }

  saveBirthday(birthday: any): Promise<any> {
    const found: any = this.birthdays$.value.find((el: any) => el.turn === birthday.turn);
    const error: any = { error: true, text: "Parece que el pedido no ha llegado a cocina. Vuelva a intentarlo." };
    const success: any = { text: "Comanda enviada a cocina!" };

    return new Promise((resolve, reject) => {
      if (found) {
        this.birthdaysDB$.update(found.$key, birthday).then(() => resolve(success)).catch(() => reject(error));
      } else {
        this.birthdaysDB$.push(birthday).then(resolve.apply(this, success), reject.apply(this, error));
      }
    });
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/services/birthdays.service.ts